<div class="container">
    <div>
        <div class="img-preview-container">
            <img [src]="croppedImage" class="img-preview" />
        </div>

        <div class="img-container">
            <image-cropper
                [imageURL]="imageSource"
                [maintainAspectRatio]="true"
                [aspectRatio]="3 / 3"
                format="png"
                [canvasRotation]="canvasRotation"
                [(transform)]="transform"
                (imageCropped)="imageCropped($event)"
            ></image-cropper>
        </div>
    </div>

    <div class="submit">
        <button
            mat-raised-button
            color="primary"
            (click)="rotateImageLeft()"
            class="button-full-width"
        >
            Rotate Left
        </button>

        <button
            mat-raised-button
            color="primary"
            (click)="rotateImageRight()"
            class="button-full-width"
        >
            Rotate Right
        </button>

        <button mat-raised-button color="primary" (click)="submit()" class="button-full-width">
            Submit
        </button>

        <button
            mat-raised-button
            color="primary"
            (click)="closeCropper()"
            class="button-full-width"
        >
            Close
        </button>
    </div>
</div>
